import { config } from '@/config/env'

export interface Project {
  id: string
  name: string
  description: string
  createdAt: string
  updatedAt: string
}

/**
 * Obtiene todos los proyectos disponibles
 */
export const getProjects = async (): Promise<Project[]> => {
  const token = localStorage.getItem('access_token')
  
  if (!token) {
    throw new Error('No hay token de autenticación')
  }

  const response = await fetch(`${config.apiBaseUrl}/projects`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || 'Error al obtener los proyectos')
  }

  const data = await response.json()
  return data
}

export const getProjectsPublicAll = async (): Promise<Project[]> => {
  const token = localStorage.getItem('access_token')

  if (!token) {
    throw new Error('No hay token de autenticación')
  }

  const response = await fetch(`${config.apiBaseUrl}/projects/public/all`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || 'Error al obtener el catálogo de proyectos')
  }

  const data = await response.json()
  return data
}

export const getProjectsAssigned = async (): Promise<Project[]> => {
  const token = localStorage.getItem('access_token')
  
  if (!token) {
    throw new Error('No hay token de autenticación')
  }

  const response = await fetch(`${config.apiBaseUrl}/projects/assigned`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || 'Error al obtener los proyectos')
  }

  const data = await response.json()
  return data
}
